import SelectedTranscriptHighlight from './SelectedTranscriptHighlight'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class TextClipMain extends Component {
  static propTypes = {
    clip: PropTypes.object.isRequired,
    searchHighlights: PropTypes.array
  }

  render() {
    const { clip, searchHighlights } = this.props

    return (
      <SelectedTranscriptHighlight
        transcript={clip.transcript}
        startOffset={clip.startWordIndex}
        endOffset={clip.endWordIndex}
        searchHighlights={searchHighlights}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TextClipMain.js